import { SectionHead } from '../../ui/SectionHead';
import './styles.css';
import HumanIcon from '../../../assets/people/Human1.jpg';
import HumanIcon2 from '../../../assets/people/Human2.png';
import HumanIcon3 from '../../../assets/people/Human3.png';
import HumanIcon4 from '../../../assets/people/Human4.png';
import HumanIcon5 from '../../../assets/people/Human5.png';
import HumanIcon6 from '../../../assets/people/Human6.png';

export function Projects() {
  return (
    <section id="projects" className="section">
      <div className="container">
        <SectionHead
          align="center"
          title={
            <>
              Real Projects, <span className="accent">Real Impact</span>
            </>
          }
          subtitle="See what happens when diverse minds collaborate."
        />
        <div className="projectGrid">
          <article className="projectCard">
            <div className="projectTop">
              <div className="avatars" aria-hidden="true">
                <img src={HumanIcon} alt="University of Cambridge" className="avatar" />
                <img src={HumanIcon2} alt="University of Cambridge" className="avatar" />
                <img src={HumanIcon3} alt="University of Cambridge" className="avatar" />
              </div>
              <span className="status statusGreen">Completed</span>
            </div>
            <h3>AI-Driven Language Tutor</h3>
            <p className="muted">
              A cross-university team built a prototype that secured funding from a European tech incubator.
            </p>
            <div className="tags">
              <span className="tag">Computer Science</span>
              <span className="tag">Linguistics</span>
            </div>
          </article>
          <article className="projectCard">
            <div className="projectTop">
              <div className="avatars" aria-hidden="true">
                <img src={HumanIcon4} alt="University of Cambridge" className="avatar" />
                <img src={HumanIcon5} alt="University of Cambridge" className="avatar" />
                <img src={HumanIcon6} alt="University of Cambridge" className="avatar" />
              </div>
              <span className="status statusBlue">Active</span>
            </div>
            <h3>Urban Farming Logistics</h3>
            <p className="muted">Optimizing supply chains for vertical farms in dense European metropolitan areas.</p>
            <div className="tags">
              <span className="tag">Logistics</span>
              <span className="tag">Agriculture</span>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}

